export default { 
    data: function() {
        return {
            uploads: [],
            uploadUrl: process.env.VUE_APP_UPLOAD,
            uploadHeaders: {
                "AUTH-ADMIN": localStorage.getItem("AUTH-ADMIN"),
                "AUTH-COMPANY": localStorage.getItem("AUTH-COMPANY")
            }
        }
    },
    methods: {
        uploadSuccessSingle: function(res) {
            for (let i = 0; i < this.uploads.length; i++) {
                if (this.uploads[i].column == res.columnName) {
                    if (this.uploads[i].files.length == 0) {
                        this.uploads[i].files.push(res.fileName);
                    }
                    else {
                        this.uploads[i].files[0] = res.fileName;
                    }
                }
            }
            
            this.$forceUpdate();
        },
        uploadSuccessMulti: function(res) {
            for (let i = 0; i < this.uploads.length; i++) {
                if (this.uploads[i].column == res.columnName) {
                    this.uploads[i].files.push(res.fileName);
                }
            }
        },
        beforeHandleOpen: function() {
            console.log("111")
            if (this.handle == "insert") {
                for (let i = 0; i < this.uploads.length; i++) {
                    this.uploads[i].files = [];
                }
            }
            else if (this.handle == "update" || this.handle == "detail") {
                for (let i = 0; i < this.uploads.length; i++) {
                    if (this.handleInfo[this.uploads[i].column]) {
                        this.uploads[i].files = this.handleInfo[this.uploads[i].column].split(",");
                        console.log(this.uploads[i].column)
                        console.log(this.uploads[i].files)
                    }
                }
            }
        },
        beforeHandleSubmit: function() {
            for (let i = 0; i < this.uploads.length; i++) {
                this.handleInfo[this.uploads[i].column] = this.uploads[i].files.join(",");
            }
        },
        afterHandleSubmit: function() {
            for (let i = 0; i < this.uploads.length; i++) {
                this.uploads[i].files = [];
            }
        },
        uploadRemove: function(column, index) {
            for (let i = 0; i < this.uploads.length; i++) {
                if (this.uploads[i].column == column) {
                    this.uploads[i].files.splice(index, 1);
                }
            }
        },
        getFiles: function(column) {
            var files = [];
            for (let i = 0; i < this.uploads.length; i++) {
                if (this.uploads[i].column == column) {
                    files = this.uploads[i].files;
                }
            }
            return files;
        },
        getFilesByStr: function(str) {
            var files = [];
            if (str) {
                let arr = str.split(",");
                for (let i = 0; i < arr.length; i++) {
                    files.push(arr[i]);
                }
            }
            return files;
        }
    }
}